import "./App.css";
import { useState } from "react";
import NavBar from "./components/NavBar";
import { Routes, Route } from "react-router-dom";
import Search from "./components/Search";
import Home from "./Home";
import Privacy from "./Privacy";
import Footer from "./components/Footer";
import BISMage from "./pages/bis_mage";
import BISDK from "./pages/bis_deathknight";
import BISDruid from "./pages/bis_druid";
import BISHunter from "./pages/bis_hunter";
import BISPriest from "./pages/bis_priest";
import BISPaladin from "./pages/bis_paladin";
import BISRogue from "./pages/bis_rogue";
import BISShaman from "./pages/bis_shaman";
import BISWarlock from "./pages/bis_warlock";
import BISWarrior from "./pages/bis_warrior";

function App() {
  return (
    <>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/search" element={<Search />} />
        <Route path="/bis/mage" element={<BISMage />} />
        <Route path="/bis/deathknight" element={<BISDK />} />
        <Route path="/bis/druid" element={<BISDruid />} />
        <Route path="/bis/hunter" element={<BISHunter />} />
        <Route path="/bis/priest" element={<BISPriest />} />
        <Route path="/bis/paladin" element={<BISPaladin />} />
        <Route path="/bis/rogue" element={<BISRogue />} />
        <Route path="/bis/shaman" element={<BISShaman />} />
        <Route path="/bis/warlock" element={<BISWarlock />} />
        <Route path="/bis/warrior" element={<BISWarrior />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
